import { snakeCase } from 'lodash';

/*
  TODO: unit-qty no longer has a getUnits function so we need to either maintain this, add that function back
  to unit-qty, or not use this UNIT_TYPES array. This object is taken directly from unit-qty's alias object.

  My opinion: add function back to unit-qty > maintain this array > use strings instead of array
  The array is a nice tool to have and pulling units from unit-qty will ensure that the unit keys are used corectly
*/

export const UNIT_QTY_UNIT_TYPES = {
  'acre': 'ac',
  'hectare': 'ha',
  'm^2': 'meter^2',

  'millimeter': 'mm',
  'centimeter': 'cm',
  'meter': 'm',
  'meters': 'm',
  'kilometer': 'km',
  'inch': 'in',
  'foot': 'ft',
  'yard': 'yd',
  'mile': 'mi',

  'celsius': 'c',
  'fahrenheit': 'f',
  'kelvin': 'K',

  'kilogram': 'kg',
  'pound': 'lb',
  'pounds': 'lb',
  'lbs': 'lb',
  'metric-ton': 'mt',
  'tonne': 'mt',
  'ton': 'short-ton',

  'seed/acre': 'seed/ac',
  'seeds/acre': 'seeds/ac',
  'kiloseed/acre': 'k seed/ac',
  'seed/hectare': 'seed/ha',
  'kiloseed/hectare': 'k seed/ha',

  'mile/hour': 'mph',
  'kilometer/hour': 'kph',
  'meter/second': 'm/s',

  'tonne/acre': 'mt/ac',
  'kilogram/acre': 'kg/ac',
  'pound/acre': 'lb/ac',
  'lbs/ac': 'lb/ac',
  'lbs N/ac': 'lb/ac',
  'kilogram/hectare': 'kg/ha',
  'kg/hectare': 'kg/ha',
  'bags/hectare': 'bag/ha',
  'bags/ha': 'bag/ha',
  'tonne/hectare': 'mt/ha',
  'mT/ha': 'mt/ha',

  'gallon/hour': 'gal/h',
  'liter/hour': 'l/h',

  'second': 's',

  'gdus': 'gduc',
  'lbs/gal': 'lb/gal',
  'lbs N/1,000 gallons': 'lb/1000 gal',
  'lbs/bu': 'lb/bu',
  'tons N/ac': 'ton/ac',
  'gdu': 'gduc',
  'gal/hr': 'gal/h',
  'l/hr': 'l/h',
  'cmol/kg': 'cmole/kg'
};

// Unit types recognized by Script Creator. See
// https://git.tcc.li/projects/WEB/repos/unit-qty/browse/src/uomJson/units.json
// for the list from the unit-qty library. format here is snakeCase,
// ie spaces, slashes, etc. replaced by underscore (_)
export const UNIT_TYPES = [].concat(
  Object.keys(UNIT_QTY_UNIT_TYPES),
  Object.values(UNIT_QTY_UNIT_TYPES),
  [
    // keys without unit-qty aliases
    'bu/ac',
    'l/ha',
    'gal/ac',
    'corn-bag',
    'corn-seed',
    'soybean-bag',
    'soybean-seed',
    'bag/1000 soybean-seed',
    'bag/1000 corn-seed',
    'usd/acre',
    'bag',
    'percent',
    'bu',

    'cad',
    'gal', // Changed from gallon so it matches unit-qty

    // used for weighted seed amount, not dependent on type of seed currently.
    // could switch to corn_seed or soy_seed from unit-qty.
    'seed',
    'usd',
    'usd/bag',
    'usd/bu',
    'usd/ha',
    'usd/kg', // usd_kg, used by hank
    'usd/mt',
    'usd/thousand' // usd_thousand, used by hank
  ]
).reduce((result, key) => { result[snakeCase(key)] = key; return result; }, {});
